import AboutHero from '@/components/About/AboutHero';
import AboutShowcase from '@/components/About/AboutShowcase';
import AboutCTA from '@/components/About/AboutCTA';
import AboutMissionVision from '@/components/About/AboutMissionVision';
import AboutTeam from '@/components/About/AboutTeam';

export default function About() {
  return (
    <>
      <AboutHero />
      <AboutShowcase />
      <AboutCTA />
      <AboutMissionVision />
      <AboutTeam />
    </>
  );
}
